// Module
var code = "<div data-region=\"lines\"></div> <div data-region=\"formSection\" style=\"display:none\"> <div data-region=\"form\"></div> <div class=\"text-center my-md-5\"> <div class=\"d-inline-block mx-auto\"> <div data-region=\"ups\"></div> </div> </div> </div> ";
// Exports
module.exports = code;